export default (state = {}, { type, payload }) => {
    switch (type) {
        case 'ZOOM_EVENT':
            return payload
        case 'LOGOUT':
            return null
        default:
            return state
    }
}